// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2025-12-11T09:41:38+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  190779
//    Project:        555
//    Environment:    5341 - master
//    MD5:            411aebe010730c83f7a0570a08d4d193
//    Signature:      eyJpdiI6IjlMMnVUQ3pMQUJYXC9oajllR01hNzV3PT0iLCJ2YWx1ZSI6Ilc0OGlEaHhhMVMwdDQ5a3lGMUt6ZHFVRW9wd2RSN2J1WGFnbHFkQ2VpbTQ3Z0N3MjAwU0ZmSnBaZW1MdnBZRGtpbTZVUW1oZnB5SkREQ1V6NWlJNlVwUWJESE82aGtia2tnMWVrQ0FxeGZ4UnFkY2RNNFNDaStFSmpuNWhzQ3pUYnByRVJqNXdcL0VHTU1IZ1k0b0pWSnNTdHdEK2gzRWtGN2JTb00wNEZxZU84NzB4Y3g4UXVuUVZUQ3Y0NU9wZ29rTmVqMWs1ZHFZZG10a0h5dU9nVnRkSzVtdFZUN3dXWnJ1bHYrRyt3WitjTE1xRWg3WkQrYVRuSWdZcFppMG90K2diVXVoSmRkU3I4bzlWVlJXb1BCZE9xMURBSGxjS2UrUEhPQ29mKys0THpcL3E0dUFuajNBV1ZVK3NhbkViTDFuemlpWXJoRCtGd3kyaFkrdFRPM29icGVMdkx2OGNVR1ZNXC9leVd4VEwxK2dsN2sxZGp1UDZMOWdVVllOdG1EcURnbysxOXNpOVBHZnlcL1wvYmk5TVN2QT09IiwibWFjIjoiMWYxMWRjMzQ3YTkyN2Q1MWJjMTJjZGJjNmMyM2EyYWE4MmNiYjEwNmExZTA0ZDljYjI3Y2MwZWM3MzRlOTE3ZiJ9
document.addEventListener("DOMContentLoaded", () => {
  const icons = document.querySelectorAll(".icon--loyalty");

  if (icons) {
    icons.forEach((icon) => {
        const frames = icon.querySelectorAll(".frame");
        if (frames.length === 0) return;

        const interval = 95;
        const finalHold = 3000;
        const fadeDuration = 500;

        let current = 0;

        function showFrame(index) {
        frames.forEach((frame, i) => {
            frame.style.opacity = i === index ? "1" : "0";
        });
        }

        function animateFrames() {
        showFrame(current);

        const isLast = current === frames.length - 1;
        const delay = isLast ? finalHold : interval;

        setTimeout(() => {
            if (isLast) {
            // Fade out last frame
            frames[current].style.opacity = "0";
            setTimeout(() => {
                current = 0;
                animateFrames();
            }, fadeDuration);
            } else {
            current++;
            animateFrames();
            }
        }, delay);
        }

        animateFrames();
    });
    }
});
